export const formatAmount = (amount) => {
  if (amount && amount.currency) {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: amount.currency }).format(amount.amount);
  }
  return '';
}
